import { render, staticRenderFns } from "./accountSafety.vue?vue&type=template&id=351e4a33&scoped=true&"
import script from "./accountSafety.vue?vue&type=script&lang=js&"
export * from "./accountSafety.vue?vue&type=script&lang=js&"
import style0 from "./accountSafety.vue?vue&type=style&index=0&id=351e4a33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e4a33",
  null
  
)

export default component.exports